import { InjectionToken } from "@angular/core";

export interface CloudSpecificationApiConfig {
	portalBackendUrl?: string;
}

export const CLOUD_SPECIFICATION_API_CONFIG = new InjectionToken<CloudSpecificationApiConfig>(
	"CloudSpecificationApiConfig",
);
